import styled from 'styled-components'
import { sizes, colors } from 'config/ui'
import { tokens } from '@arvoreeducacao/bonsai-ds'

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: ${tokens.fontWeights.bold};
  margin-bottom: 20px;

  strong {
    font-size: ${sizes.h[3]}px;
    font-weight: 700;
    color: ${colors.gray9};
    margin-right: 10px;
  }
`

export const Wrapper = styled.div`
  padding: ${({ noPadding }) => (noPadding ? '0px' : '20px')};
  position: relative;
`

export const Content = styled.div``
